module.exports = __webpack_public_path__ + "static/media/truck-gray.18b6d77d.svg";